import { render } from "./backorders_import.vue?vue&type=template&id=0ce3eea7&scoped=true"
import script from "./backorders_import.vue?vue&type=script&lang=js"
export * from "./backorders_import.vue?vue&type=script&lang=js"

import "./backorders_import.vue?vue&type=style&index=0&id=0ce3eea7&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce3eea7"]])

export default __exports__